import { formatHtml } from "@trumpf/ux.common-storybook";
import { TemplateQuoteList } from "./quote-lists.templates";

export default {
    title: "Website/Partial Templates/Quote Lists (B.7)",
    render: TemplateQuoteList.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
